import { Palette } from 'lucide-react'
import { useState } from 'react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { type CoverSubject, EventAiChat } from './event-ai-chat'

interface EventFormValues {
  title: string
  description: string
  startTime: string
  occurrences: { date: string; startTime: string; isAllDay?: boolean }[]
}

/** Title, plain description and start of the event as the form holds them right now. */
export function coverSubjectOf(values: EventFormValues): CoverSubject {
  const first = values.occurrences[0]
  const start = first?.date
    ? first.isAllDay || !first.startTime
      ? first.date
      : `${first.date}T${first.startTime}`
    : values.startTime
  const description = values.description
    ? (new DOMParser().parseFromString(values.description, 'text/html').body.textContent ?? '')
    : ''
  return { title: values.title.trim(), description: description.trim(), startTime: start || null }
}

const NO_SUBJECT = (): CoverSubject => ({ title: '', description: '', startTime: null })

/** Opens the Pulsify chat at the cover step and puts the finished cover in front. */
export function CoverChatButton({
  onCover,
  subject = NO_SUBJECT,
}: {
  onCover: (file: File) => void
  subject?: () => CoverSubject
}) {
  const { data: business } = useCurrentBusiness()
  const [open, setOpen] = useState(false)
  const [opened, setOpened] = useState(false)
  if (!business) return null
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => {
          setOpened(true)
          setOpen(true)
        }}
      >
        <Palette className="h-4 w-4" />
        {m.eventCoverChatOpen()}
      </Button>
      {opened && (
        <EventAiChat
          mode="cover"
          businessId={business.id}
          open={open}
          onOpenChange={setOpen}
          subject={subject}
          onCover={onCover}
        />
      )}
    </>
  )
}
